import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-transparent text-gray-400 py-6 w-full" data-id="element-140">
      <div className="container mx-auto px-4" data-id="element-141">
        <div className="text-center text-sm" data-id="element-142">
          <p data-id="element-143">© 2025 Callvana. All rights reserved.</p>
          <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-light transition-colors mt-1 inline-block" data-id="element-144">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
};